import React from 'react';
import { CheckIcon, TrophyIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { launchOffer, priceIncludes } from '../data/content';
export function Pricing() {
  return <section id="precio" className="bg-night" data-id="element-202" data-mp="2oj8rpo8fcdgs">
      <div className="mx-auto max-w-content px-6 py-16 lg:py-24" data-id="element-203" data-mp="2ohxopqmsz9qq">
        <div className="mx-auto max-w-2xl text-center" data-id="element-204" data-mp="2jjcqfwr4304x">
          <h2 className="font-display text-3xl font-semibold leading-tight tracking-tight text-parchment sm:text-4xl" data-id="element-205" data-mp="2jlywfryct7l1">
            💳 Valor y acceso
          </h2>
          <p className="mt-3 font-sans text-base text-parchment/65" data-id="element-206" data-mp="1ru15edzze0bt">
            Un solo pago. Acceso de por vida a los 73 mapas y a los 4 bonos.
          </p>
        </div>

        <div className="mx-auto mt-10 max-w-xl rounded-3xl border border-gold-soft/50 bg-night-panel p-7 text-center lg:p-10" data-id="element-207" data-mp="20sv7gjw2ziwr">
          <TrophyIcon className="mx-auto h-8 w-8 text-gold-soft" aria-hidden="true" data-id="element-208" data-mp="3h5tjuqwq4tle" />
          <h3 className="mt-4 font-display text-2xl font-semibold text-parchment" data-id="element-209" data-mp="3c7i82amvc90j">
            GPS Bíblico completo
          </h3>
          <p className="mt-2 font-sans text-sm text-parchment/60" style={{
          fontSize: "16px",
          fontWeight: "500"
        }} data-id="element-210" data-mp="3w1jf607e8fxs">
            73 mapas · 4 bonos de regalo · 100% PDF
          </p>

          <p className="mt-6 font-sans text-lg text-parchment/45 line-through" data-id="element-211" data-mp="9qe7fny47w4k">
            {launchOffer.regularPrice}
          </p>
          <p className="font-display text-5xl font-semibold text-gold-soft sm:text-6xl" data-id="element-212" data-mp="3d9h5j8t65zx1">
            {launchOffer.price}
          </p>
          

          <div className="mt-8" data-id="element-213" data-mp="3i8bocar4zoh5">
            <CtaButton size="block" data-id="element-214" data-mp="3n7ew42yi48st">🙏 Quiero mi GPS Bíblico</CtaButton>
          </div>

          <ul className="mt-8 space-y-3 text-left" data-id="element-215" data-mp="3rxv7zimobmd2">
            {priceIncludes.map(item => <li key={item} className="flex gap-3" data-id="element-216" data-mp="3rzy7qudmotuz">
                <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-gold-soft" aria-hidden="true" data-id="element-217" data-mp="2uj98n8g2c5pa" />
                <span className="font-sans text-base text-parchment/80" data-id="element-218" data-mp="2zgrc4jbb9spw">{item}</span>
              </li>)}
          </ul>

          
        <p className="mt-8 border-t border-night-line pt-6 font-sans text-sm text-parchment/55" style={{
          fontSize: "16px",
          paddingRight: "0px",
          width: "257px",
          height: "84px",
          textAlign: "center",
          paddingTop: "23px"
        }} data-id="element-219" data-mp="2rfa6vsv0ulhz">
            🔒 Pago 100% seguro · ⚡ Acceso inmediato · 🛡️ Garantía 7 días
          </p></div>
      </div>
    </section>;
}